import { IBaseAllergy } from '../../../interfaces';
import { BaseAllergyToMedicalHistoryMappingHandler } from '../../../mappings/allergy-to-medical-history';
import {
  CorePracticePatientAllergyOptions,
  ICorePracticePatientAllergyOptions,
  PatientAllergyOptionsSourceEntity,
} from '../../source/entities/patient-allergy-options';

export class CorePracticeAllergyMappingHandler extends BaseAllergyToMedicalHistoryMappingHandler<
  CorePracticePatientAllergyOptions,
  PatientAllergyOptionsSourceEntity
> {
  override sourceEntity = new PatientAllergyOptionsSourceEntity();
  translateFn = (record: ICorePracticePatientAllergyOptions): IBaseAllergy => ({
    description: record.description,
    id: record.description,
  });
}
